// Shared tokens and the two derivations the panel needs live, before a save.
export const S = {
  ink: "#1A1A1A", ink2: "#59554D", ink3: "#8A857A", muted: "#B5AFA3",
  card: "#FFFFFF", panel: "#F6F4EF", border: "#DAD5CA", divider: "#EDE9E0",
  accent: "#FFD108", accentEdge: "#E0B800", accentInk: "#8A6D00",
  good: "#0E6B3F", bad: "#C23A00",
};
export const MANROPE = { fontFamily: "Manrope, sans-serif" };
export const FOCUS = "focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD108]";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api/social`;

export const productOf = (settings, key) =>
  (settings?.products || []).find((p) => p.key === key) || {};

export const trackedUrl = (post, settings, network = "linkedin") => {
  const prod = productOf(settings, post.product);
  let base = (post.destination_url || prod.landing_url || "").trim();
  if (!base || !base.startsWith("http")) return null;
  base = base.split("?")[0];
  const campaign = (post.utm_campaign || post.campaign || "").trim();
  const source = network === "meta"
    ? settings?.utm_source_meta || "facebook"
    : settings?.utm_source_linkedin || "linkedin";
  const bits = [`utm_source=${source}`, `utm_medium=${settings?.utm_medium || "social"}`];
  if (campaign) bits.push(`utm_campaign=${campaign.toLowerCase().replace(/\s+/g, "_")}`);
  if (prod.utm_slug) bits.push(`utm_content=${prod.utm_slug}`);
  return `${base}?${bits.join("&")}`;
};

export const fullDesignPrompt = (post, settings) => {
  const template = ((settings?.stream_templates || {})[post.stream || ""]
    || productOf(settings, post.product).design_template || "").trim();
  return [template, (post.design_prompt || "").trim()].filter(Boolean).join("\n\n");
};

// Dates read the Australian way everywhere: 07-Oct-2026.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const auDate = (value, fallback = "—") => {
  const iso = String(value || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return value ? String(value) : fallback;
  const [y, m, d] = iso.split("-");
  return `${d}-${MONTHS[Number(m) - 1]}-${y}`;
};

export const auDateTime = (value) => {
  if (!value) return "—";
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return String(value);
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(dt.getDate())}-${MONTHS[dt.getMonth()]}-${dt.getFullYear()} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
};

/* Accepts what someone would actually type — 7 Oct 2026, 07-Oct-2026, 7/10/2026,
   2026-10-07 — and returns the ISO date the API stores. null when it isn't a date. */
export const parseAuDate = (text) => {
  const raw = String(text || "").trim();
  if (!raw) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  const named = raw.match(/^(\d{1,2})[\s\-/]+([A-Za-z]{3,})[\s\-/]+(\d{2,4})$/);
  if (named) {
    const month = MONTHS.findIndex((m) => named[2].toLowerCase().startsWith(m.toLowerCase()));
    if (month < 0) return null;
    const year = named[3].length === 2 ? `20${named[3]}` : named[3];
    return `${year}-${String(month + 1).padStart(2, "0")}-${named[1].padStart(2, "0")}`;
  }
  const numeric = raw.match(/^(\d{1,2})[\s\-/](\d{1,2})[\s\-/](\d{2,4})$/);
  if (numeric) {
    const year = numeric[3].length === 2 ? `20${numeric[3]}` : numeric[3];
    return `${year}-${numeric[2].padStart(2, "0")}-${numeric[1].padStart(2, "0")}`;
  }
  return null;
};
